let Test = require('@/mixins/Forms/2022/NRCA_LTI_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection`,
                    code_reference: `NA7.6.2.1`,
                    questions: {
                        question_1: {
                            id: `1`,
                            type: 'Boolean',
                            question: `The occupant sensing lighting controls are shown on plan documents and are installed.`,
                            code_reference: `NA7.6.2.1(a)`,
                            answer: false
                        },
                        question_2: {
                            id: `2`,
                            type: 'Boolean',
                            question: `Occupant sensing lighting control is installed per manufacturer’s instructions to minimize false triggering – such as to install an occupancy sensor away from HVAC diffusers to avoid probable false triggering.`,
                            code_reference: `NA7.6.2.1(c)`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: ` Functional Testing`,
                    code_reference: `NA7.6.2.5`,
                    steps: {
                        step_1: {
                            id: `1`,
                            name: `Simulate an unoccupied condition in the controlled space.`,
                            code_reference: `NA7.6.2.3(a)`,
                            questions: {
                                question_1: {
                                    id: `1.1`,
                                    type: 'Boolean',
                                    question: `The occupant sensing control turn the controlled lighting off or partially off, if applicable, in 20 minutes or less from start of an unoccupied condition. In addition:<br>
                                    For partial-on occupant sensing controls, occupant sensing controls and vacancy sensing controls, the controlled lighting is turned off in unoccupied condition.<br><br>
                                                    In the partial off state, partial OFF occupant sensing controls automatically reduce lighting power by at least 50%, <b>OR</b>:
                                                    <ul class="test-list-points">
                                                        <li>For warehouses with metal halide or high pressure sodium lighting, automatically reduce lighting power by at least 40%.</li>
                                                        <li>For aisle ways and open areas in warehouses in which the installed lighting power is 80 percent or less of the value allowed under the Area Category Method, automatically reduce lighting power by at least 40%.</li>
                                                        <li>In corridors and stairwells that provide access to guestrooms in hotel/motels in which the installed lighting power is 80 percent or less of the value allowed under the Area Category Method, automatically reduce lighting power by at least 40%.</li>
                                                    </ul>
                                    For parking garages, parking areas, and loading and unloading areas, occupant sensing controls have at least one control step between 20 to 50 percent of design lighting power, OR Occupant sensing controls for metal halide luminaires with a lamp plus ballast mean system efficacy of 75 lumens per watt, in parking garages, parking areas, and loading and unloading areas, have at least one control step between 20 to 60 percent of design lighting power..`,
                                    code_reference: `NA7.6.2.3(a)1 §110.9(b)4A<br><br>§130.1(c)6A-C §130.1(c)7A §160.5(b)4Cvia<br><br>§130.1(c)7B §160.5(b)4Cviib`,
                                    answer: false
                                },
                            }
                        },
                        step_2: {
                            id: `2`,
                            name: `Simulate an occupied condition in the controlled space.`,
                            code_reference: `NA7.6.2.3(b)`,
                            questions: {
                                question_1: {
                                    id: `2.1`,
                                    type: 'Boolean',
                                    question: `Status indicator or annunciator operates correctly.`,
                                    code_reference: `NA7.6.2.3(b)1, Section 110.9(b)4C`,
                                    answer: false
                                },
                                question_2: {
                                    id: `2.2`,
                                    type: 'Boolean',
                                    question: `Immediately upon an occupied condition:<br>
                                     <ul class="test-list-points">
                                        <li>The occupant sensing control or partial off occupant sensing control turns on controlled lighting; <b>OR</b></li>
                                        <li>The vacancy sensing control indicate a space is occupied and the controlled lighting can be turned on manually; <b>OR</b></li>
                                        <li>The partial-on occupant sensing controls automatically turns on the controlled lighting at between 50 to 70 percent of controlled lighting power. After the partial-on stage, manual switches can be activated to turn on the controlled lighting at full controlled lighting power.</li>
                                    </ul>`,
                                    code_reference: `NA7.6.2.3(b)2<br><br>Section 130.1(c)5A, Section 160.5(b)4Cva`,
                                    answer: false
                                },
                            }
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },
}


